import StudyBrowser from './StudyBrowser';
export default StudyBrowser;
